import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import Tooltip from "@mui/material/Tooltip";
import { motion } from "framer-motion";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useProfile } from "../../contexts/ProfileContext.tsx";
import RastrearRedux from "../../contexts/Rastreio";
import RequestControllerRedux from "../../contexts/RequestController";
import TabelaRedux from "../../contexts/Tabela";
import IconButton from "../../core/components/IconButton.tsx";
import RenderCsvLink from "../../core/components/RenderCsvLink.tsx";
import { recusaSolicitacao } from "../../services/ModuloGerenciador/Solicitacao";
import ItemNotFound from "../ItemNotFound/ItemNotFound.tsx";
import LoadingComponent from "../LoadingComponent/LoadingComponent.tsx";
import ModalConfigTabela from "../ModalConfigTabela/ModalConfigTabela.tsx";
import ModalFiltroCidade from "../ModalFiltroCidade/ModalFiltroCidade.tsx";
import Text from "../Text/Text";
import ToastErro from "../Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../Toast/ToastSucesso/ToastSucesso.tsx";
import "./TabelaV2.css";
import TableBodyDesordenado from "./components/TableBodyDesordenado";
import TableBodyOrdenado from "./components/TableBodyOrdenado.tsx";
import TableHeader from "./components/TableHeader.tsx";

const chavesRemover = [
	"deletado",
	"embarqueHistoricoId",
	"contexto",
	"dataHoraChegadaEmbarque",
	"dataHoraEmbarcado",
	"dataHoraChegadaEntrega",
	"dataHoraEntregue",
	"data",
	"usuario",
];

const chavesFormatar = [
	"previsaoEmbarque",
	"dataEmbarque",
	"previsaoEntrega",
	"dataEntrega",
];

function converteDataPadrao(data) {
	return new Date(data).toLocaleDateString("pt-BR", {
		month: "numeric",
		day: "numeric",
	});
}

function converteData(DataDDMMYY) {
	const dataSplit = DataDDMMYY.split("/");
	const novaData = new Date(
		parseInt(dataSplit[2], 10),
		parseInt(dataSplit[1], 10) - 1,
		parseInt(dataSplit[0], 10)
	);
	return novaData;
}

function TabelaV2(props) {
	const { contextoEmbarque, profile, tabelaEmpresa, tabelaUsuario } =
		useProfile();

	const navigate = useNavigate();

	const location = useLocation();

	const [searchParams] = useSearchParams();

	const id = useMemo(() => searchParams.get("id"), [searchParams]);

	const {
		setColunaSelecionada,
		setOpenRegras,
		classeSelecionado,
		setTelaCadastro,
		setEditando,
		setIdEmbarque,
		setTelaCheck,
		buscarOrdenacao,
		colunas,
		dados,
		nomeTable,
		setValues
	} = props;

	const isRotaViagens = useMemo(() => {
		return (
			location.pathname.includes("/viagens/") ||
			location.pathname.includes("/faturamento")
		);
	}, [location.pathname]);

	const isRotaViagensDeletada = useMemo(() => {
		return location.pathname === "/viagens-deletadas";
	}, [location.pathname]);

	const isRotaVeiculosVencidos = useMemo(() => {
		return location.pathname === "/veiculos-vencidos";
	}, [location.pathname]);

	const isRotaPedidos = useMemo(() => {
		return location.pathname === "/pedido";
	}, [location.pathname]);

	const isRotaModeloViagens = useMemo(() => {
		return location.pathname === "/modelo-viagens";
	}, [location.pathname]);

	const isRotaViagensFinalizadasMotorista = useMemo(() => {
		return location.pathname === "/viagens-finalizadas-motorista";
	}, [location.pathname]);

	const configDataHora = useMemo(() => {
		return tabelaUsuario[nomeTable]?.[50]?.configDataHora;
	}, [nomeTable, tabelaUsuario]);

	const configEntrega = useMemo(() => {
		return tabelaUsuario[nomeTable]?.[51]?.configEntrega;
	}, [nomeTable, tabelaUsuario]);

	const shouldShowCsv = useMemo(() => {
		return (
			!isRotaViagens &&
			!isRotaViagensDeletada &&
			!isRotaViagensFinalizadasMotorista
		);
	}, [isRotaViagens, isRotaViagensDeletada, isRotaViagensFinalizadasMotorista]);

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);
	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);
	const { setDadosRastrearRedux } = useContext(RastrearRedux);

	let novaArray = [];

	if (!Array.isArray(dados)) {
		novaArray.push(dados);
	} else {
		novaArray = dados;
	}

	const listaFiltradaObjetos = novaArray.map((obj) => {
		const novoObjeto = Object.keys(obj)
			.filter((key) => !chavesRemover.includes(key))
			.reduce((novoObjeto, key) => {
				novoObjeto[key] = obj[key];
				return novoObjeto;
			}, {});
		return novoObjeto;
	});

	const listaFormatada = listaFiltradaObjetos.map((obj) => {
		const novoObj = {};
		Object.keys(obj).forEach((key) => {
			if (chavesFormatar.includes(key) && obj[key]) {
				novoObj[key] = obj[key].replace(/T00:00:00/, "");
			} else {
				novoObj[key] = obj[key];
			}
		});
		return novoObj;
	});

	const [hoveredColumn, setHoveredColumn] = useState(null);

	const [values2, setValues2] = useState([]);

	const [striped] = useState(true);

	const [data, setData] = useState([]);

	const [selecionado, setSelecionado] = useState("");

	const [quebraTabelaPedido] = useState(tabelaEmpresa.Pedido[17]);

	const [quebraTabelaEmbarque] = useState(tabelaEmpresa.Embarque[49]);

	const [dadosFiltrados, setDadosFiltrados] = useState([]);

	const [openFiltroCidade, setOpenFiltroCidade] = useState(false);

	const [odenConfig, setOpenConfig] = useState(false);

	const [menuConfig, setMenuConfig] = useState(false);

	const [textoErro, setTextoErro] = useState("");

	const [textoSucesso, setTextoSucesso] = useState("");

	const [dadosEntrega, setDadosEntrega] = useState([]);

	const [linhaSelecionada, setLinhaSelecionada] = useState([]);

	const [openMotivo, setOpenMotivo] = useState(false);

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const [openToastErro, setOpenToastErro] = useState(false);

	const showDropDowEmbarques = (row) => {
		setDadosEntrega((prevState) => ({
			...prevState,
			[row.idEmbarque]: row.entrega,
		}));
		if (linhaSelecionada.includes(row.idEmbarque)) {
			setLinhaSelecionada(
				linhaSelecionada.filter((id) => id !== row.idEmbarque)
			);
		} else {
			setLinhaSelecionada([...linhaSelecionada, row.idEmbarque]);
		}
	};

	const handleHover = useCallback((index) => {
		setHoveredColumn(index);
	}, []);

	const handleCloseMotivo = useCallback(() => {
		setValues2({});
		setOpenMotivo(false);
	}, []);

	const handleCloseToastSucesso = useCallback(() => {
		setOpenToastSucesso(false);
	}, []);

	const handleCloseToastErro = useCallback(() => {
		setOpenToastErro(false);
	}, []);

	const handleCloseConfig = useCallback(() => {
		if (dadosRequestControllerRedux === "Sucesso") {
			setTextoSucesso("Alterado Com Sucesso");
			setOpenToastSucesso(true);
			setOpenConfig(false);
		}
		setOpenConfig(false);
	}, [dadosRequestControllerRedux]);

	const filtraData = useCallback(
		(valor) => {
			const dataInicial = converteData(converteDataPadrao(valor.embarque));
			const dataFinal = converteData(converteDataPadrao(valor.embarqueSegundo));
			if (classeSelecionado === "idEmbarque") {
				if (valor.embarque && valor.embarqueSegundo) {
					setData(
						dados.filter((data) => {
							return (
								converteData(converteDataPadrao(data.dataEmbarque)) >=
								dataInicial &&
								converteData(converteDataPadrao(data.dataEmbarque)) <= dataFinal
							);
						})
					);
				} else if (valor.embarque && !valor.embarqueSegundo) {
					setData(
						dados.filter((data) => {
							return (
								converteData(converteDataPadrao(data.dataEmbarque)) >=
								dataInicial
							);
						})
					);
				} else if (valor.embarqueSegundo && !valor.embarque) {
					setData(
						dados.filter((data) => {
							return (
								converteData(converteDataPadrao(data.dataEmbarque)) <= dataFinal
							);
						})
					);
				} else {
					setData(dados);
				}
			} else if (classeSelecionado === "idCidadeEstado") {
				if (valor.cidade && valor.estado) {
					setDadosFiltrados(
						dados.filter((data) => {
							return (
								data.cidade
									.toLowerCase()
									.includes(valor.cidade.toLowerCase()) &&
								data.estado.toLowerCase().includes(valor.estado.toLowerCase())
							);
						})
					);
				} else if (valor.cidade && !valor.estado) {
					setDadosFiltrados(
						dados.filter((data) => {
							return data.cidade
								.toLowerCase()
								.includes(valor.cidade.toLowerCase());
						})
					);
				} else if (valor.estado && !valor.cidade) {
					setDadosFiltrados(
						dados.filter((data) => {
							return data.estado
								.toLowerCase()
								.includes(valor.estado.toLowerCase());
						})
					);
				} else {
					setDadosFiltrados(dados);
				}
			}
		},
		[classeSelecionado, dados, setDadosFiltrados]
	);

	const handleCloseFiltroCidade = useCallback(() => {
		const dataStorage = localStorage.getItem("filtros");
		if (dataStorage) {
			const storageParse = JSON.parse(dataStorage);
			if (storageParse) {
				filtraData(storageParse);
			}
		}
		setOpenFiltroCidade(false);
	}, [filtraData]);

	const filtra = useCallback(() => {
		if (
			(isRotaViagens ||
				id ||
				location.pathname === "/faturamento" ||
				location.pathname === "/aguardando-cte") &&
			contextoEmbarque !== "templateEmbarque"
		) {
			setDadosFiltrados();
		} else {
			setDadosFiltrados("1");
			var dadosfiltra = dados;
			dadosfiltra.sort(function (a, b) {
				if (
					a.placaCavalo < b.placaCavalo ||
					a.pedido < b.pedido ||
					a.cidade < b.cidade
				) {
					return -1;
				} else {
					return true;
				}
			});
			setDadosFiltrados(dadosfiltra);
		}
	}, [id, contextoEmbarque, location.pathname, dados, isRotaViagens]);

	const setTabelaRow = useCallback(
		(row) => {
			setTabelaRedux({
				colunaSelecionada: row[classeSelecionado],
				usuarioAlteracao: row.usuario,
				dataAlteracao: row.data,
				row: row,
			});
			setSelecionado(row[classeSelecionado]);
		},
		[classeSelecionado, setTabelaRedux]
	);

	const handleSingleClick = useCallback(
		(row) => {
			setTabelaRow(row);
			setColunaSelecionada && setColunaSelecionada(row[classeSelecionado]);
			setOpenRegras && setOpenRegras(true);
		},
		[classeSelecionado, setColunaSelecionada, setTabelaRow, setOpenRegras]
	);

	const handleDoubleClick = useCallback(
		(row) => {
			if (location.pathname === "/estadia") {
				setEditando(true);
				setTelaCadastro(true);
				setIdEmbarque(row.idEmbarque);
				setTabelaRow(row);
				return;
			}

			if (location.pathname !== "/diaria") {
				if (
					classeSelecionado !== "entrega-embarque" &&
					classeSelecionado !== "data" &&
					location.pathname !== "/aguardando-cte" &&
					location.pathname !== "/faturamento"
				) {
					setTabelaRow(row);
					if (
						!isRotaViagensDeletada &&
						!isRotaVeiculosVencidos &&
						contextoEmbarque !== "todos"
					) {
						setTelaCadastro && setTelaCadastro(true);
						setEditando && setEditando(true);
						navigate(`/viagens/${contextoEmbarque}/cadastro/${row.idEmbarque}`);
					} else if (isRotaViagensFinalizadasMotorista) {
						setTelaCadastro && setTelaCadastro(true);
						setEditando && setEditando(true);
						navigate("/viagens-finalizadas-motorista");
					} else {
						setTelaCheck?.();
					}
				}
			} else {
				navigate("/diarias", {
					state: { myParam: row.idGrupoCliente },
				});
			}
		},
		[
			location.pathname,
			navigate,
			classeSelecionado,
			setTelaCadastro,
			setEditando,
			setIdEmbarque,
			setTelaCheck,
			isRotaViagensDeletada,
			isRotaVeiculosVencidos,
			contextoEmbarque,
			setTabelaRow,
			isRotaViagensFinalizadasMotorista,
		]
	);

	const recusarSolicitacao = async () => {
		const objetoSolicitacao = {
			usuarioId: tabelaRedux.colunaSelecionada,
			motivo: values2.motivo,
		};
		await recusaSolicitacao(objetoSolicitacao, profile.token)
			.then((result) => {
				setDadosRequestControllerRedux("Solicitacao Recusada");
				setValues2({});
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
				}
			});
	};

	useEffect(() => {
		setDadosRastrearRedux({});
		setData(dados);
		if (props.nome) {
			setMenuConfig(true);
		}
	}, [dados, props.nome, setDadosRastrearRedux]);

	useEffect(() => {
		filtra();
	}, [filtra]);

	useEffect(() => {
		if (dados && dados.length > 0 && dados[0] && dados[0].idEmbarque) {
			const tableWrapper = document.getElementById("tableWrapper");
			if (
				tableWrapper &&
				isRotaViagens &&
				id &&
				contextoEmbarque !== "templateEmbarque"
			) {
				tableWrapper.scrollTop = tableWrapper.scrollHeight;
			}
		}
	}, [id, contextoEmbarque, dados, isRotaViagens]);

	if (props.isLoading) {
		return <LoadingComponent />;
	}

	if (dados && !dados.length) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					paddingTop: "50px",
				}}
			>
				<ItemNotFound label="Nenhum item foi localizado." />
			</div>
		);
	}

	return (
		<motion.div
			key={`${classeSelecionado}-${location.pathname}`}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
			className={
				props.nomeClasse1.includes("outer-wrapper-v2") ? "tabela-v2" : ""
			}
		>
			<div className={props.nomeClasse1}>
				{menuConfig && (
					<div className="config-tabela-v2">
						{shouldShowCsv && (
							<RenderCsvLink
								classe={classeSelecionado}
								lista={listaFormatada}
							/>
						)}
						{(isRotaPedidos || isRotaModeloViagens) && (
							<div className="filtro">
								<Tooltip title={<p>Abrir configurações colunas</p>}>
									<IconButton
										onClick={() => setOpenConfig(true)}
										className="butao-csv"
										icon="Settings"
										size="2xl"
										theme="dark"
									/>
								</Tooltip>
							</div>
						)}
						{classeSelecionado === "idCidadeEstado" && (
							<div className="filtro">
								<Tooltip title={<p>Filtros</p>}>
									<IconButton className="butao-csv" icon="Filter" size="2xl" />
								</Tooltip>
							</div>
						)}
					</div>
				)}
				<div
					className={props.nomeClasse2}
					onScroll={props.onScrollHandler}
					id="tableWrapper"
				>
					<div className="wrapper-table">
						<table className={props.breakTabela ? props.breakTabela : ""}>
							<TableHeader
								colunas={colunas}
								classeSelecionado={classeSelecionado}
								nomeTable={nomeTable}
								buscarOrdenacao={buscarOrdenacao}
								hoveredColumn={hoveredColumn}
								contextoEmbarque={contextoEmbarque}
								id={id}
								quebraTabelaEmbarque={quebraTabelaEmbarque}
								quebraTabelaPedido={quebraTabelaPedido}
							/>
							{!dadosFiltrados ? (
								<TableBodyDesordenado
									data={data}
									striped={striped}
									selecionado={selecionado}
									classeSelecionado={classeSelecionado}
									nomeTable={nomeTable}
									linhaSelecionada={linhaSelecionada}
									colunas={colunas}
									dadosEntrega={dadosEntrega}
									buscarOrdenacao={buscarOrdenacao}
									handleHover={handleHover}
									handleSingleClick={handleSingleClick}
									handleDoubleClick={handleDoubleClick}
									setDadosRastrearRedux={setDadosRastrearRedux}
									setTabelaRedux={setTabelaRedux}
									configDataHora={configDataHora}
									showDropDowEmbarques={showDropDowEmbarques}
									setColunaSelecionada={setColunaSelecionada}
									setOpenRegras={setOpenRegras}
									setOpen={props.setOpen}
									setIsEmbarque={props.setIsEmbarque}
									setIsEntrega={props.setIsEntrega}
									configEntrega={configEntrega}
								/>
							) : (
								<TableBodyOrdenado
									dadosFiltrados={dadosFiltrados}
									classeSelecionado={classeSelecionado}
									selecionado={selecionado}
									striped={striped}
									nomeTable={nomeTable}
									hoveredColumn={hoveredColumn}
									breakTd={props.breakTd}
									setOpenMotivo={setOpenMotivo}
									colunas={colunas}
									linhaSelecionada={linhaSelecionada}
									listaTipos={props.listaTipos}
									listaTipos2={props.listaTipos2}
									setOpen={props.setOpen}
									setIsEmbarque={props.setIsEmbarque}
									setDadosRastrearRedux={setDadosRastrearRedux}
									setOpenRegras={setOpenRegras}
									setIsEntrega={props.setIsEntrega}
									setValues={setValues}
									dadosEntrega={dadosEntrega}
									isEmbarque={props.isEmbarque}
									showDropDowEmbarques={showDropDowEmbarques}
									handleHover={handleHover}
									setLista={props.setLista}
									setTabelaRow={setTabelaRow}
									setIdEmbarque={setIdEmbarque}
									setDadosEmb={props.setDadosEmb}
									setTelaCadastro={setTelaCadastro}
									setEditando={setEditando}
									setTabelaRedux={setTabelaRedux}
									setOpenHistoricoEdicao={props.setOpenHistoricoEdicao}
									setTelaCheck={setTelaCheck}
									setSelecionado={setSelecionado}
									dadosOrdenados={dadosFiltrados}
									configEntrega={configEntrega}
								/>
							)}
						</table>
					</div>
				</div>
				<ModalConfigTabela
					titulo="Colunas Visíveis"
					tituloConfirmar="OK"
					open={odenConfig}
					onClose={handleCloseConfig}
					checks={colunas}
					nome={props.nome}
				/>
				<ModalFiltroCidade
					open={openFiltroCidade}
					onClose={handleCloseFiltroCidade}
				/>
				<ToastSucesso
					texto={textoSucesso}
					open={openToastSucesso}
					onClose={handleCloseToastSucesso}
				/>
				<ToastErro
					texto={textoErro}
					open={openToastErro}
					onClose={handleCloseToastErro}
				/>
				<div className="modal-usuario">
					<Dialog
						className="corpoModalCookies"
						open={openMotivo}
						onClose={handleCloseMotivo}
					>
						<DialogTitle>
							Digite porque está recusando está solicitação
						</DialogTitle>
						<DialogContent>
							<div className="principal">
								<InputLabel htmlFor="status">
									<Text texto="Motivo" />
								</InputLabel>
								<textarea
									type="text"
									className="input-text-motivo"
									rows="3"
									onChange={(e) =>
										setValues2((current) => ({
											...current,
											motivo: e.target.value,
										}))
									}
									value={values2.motivo}
								></textarea>
							</div>
						</DialogContent>
						<div className="botaoConcluir">
							<Button
								sx={{ width: 180 }}
								variant="contained"
								onClick={() => {
									recusarSolicitacao();
								}}
							>
								Recusar
							</Button>
						</div>
					</Dialog>
				</div>
			</div>
		</motion.div>
	);
}

export default TabelaV2;
